/* eslint-disable max-len */
import React, { useContext, useState, useEffect } from 'react';
import { Form, Label, Pane, Flex, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './ImageEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.forms.editors.ImageEditor');
function ImageEditor(props) {
  const {
    validator
  } = useContext(Form.Context);
  const {
    attr
  } = props;
  const [loading, setLoading] = useState(false);
  const hint = attr?.blueprint?.attribute?.getTagStartingWith('hint:', true) || t('hint');
  const value = validator.value(attr?.blueprint?.updatePath);
  useEffect(() => {
    if (value) {
      setLoading(true);
      const img = new Image();
      img.src = value;
      if (img.complete) {
        setLoading(false);
      } else {
        img.onload = () => {
          setLoading(false);
        };
        img.onerror = () => {
          validator.applyErrorState(validator.getData(), attr?.blueprint?.updatePath, 'We can\'t find or access the image at that URL. Please check again.');
          setLoading(false);
        };
      }
    }
  }, [value]);
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colS",
    children: [/*#__PURE__*/_jsx(Label, {
      variant: "inputTitle",
      children: attr.displayName
    }), /*#__PURE__*/_jsx(Form.TextInput, {
      hint: hint,
      alwaysFireOnReturn: true,
      changeOnBlur: true,
      alwaysFireOnBlur: true,
      variant: "imageUrlInput",
      name: attr?.blueprint?.updatePath,
      maxLength: 1000
    }), value && !loading && !validator.hasError(attr?.blueprint?.updatePath) && /*#__PURE__*/_jsxs(Flex, {
      variant: "colS",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "captionSmallBold",
        children: "Image Preview"
      }), /*#__PURE__*/_jsx("img", {
        src: value,
        alt: "",
        className: S.image
      })]
    }), /*#__PURE__*/_jsx(Form.Error, {
      variant: "inputCaptionSmallError",
      name: attr?.blueprint?.updatePath
    })]
  });
}
const type = 'image';
export default {
  editor: ImageEditor,
  type
};